import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

// Sæt app element for react-modal
Modal.setAppElement('#root');

const initialFormStateSprogcenter = {
    navn: '',
    adresse: '',
    postnummer: '',
    forstad: '',
    telefon: '',
    email: '',
    institutionsnummer: '',
    organisations_id: '',
    driftsaftaleperiode: '',
    tilsynskommune: '',
    udbyder_pd1: false,
    udbyder_pd2: false,
    udbyder_pd3: false,
    udbyder_sp: false,
    udbyder_vp: false
};

const API_BASE_URL_ORGANISATIONER = `${process.env.REACT_APP_API_URL}/api/organisationer`;

function SprogcentreListe() {
  const [sprogcentre, setSprogcentre] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formState, setFormState] = useState(initialFormStateSprogcenter);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editingSprogcenterId, setEditingSprogcenterId] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [organisationerOptions, setOrganisationerOptions] = useState([]);
  const [loadingOrgOptions, setLoadingOrgOptions] = useState(true);

  const API_BASE_URL_SPROGCENTRE = `${process.env.REACT_APP_API_URL}/api/sprogcentre`;

  const openModal = (sprogcenterToEdit = null) => {
    setError(null); 
    setModalError(null); 
    if (sprogcenterToEdit) {
      setEditingSprogcenterId(sprogcenterToEdit.id);
      setFormState({
        navn: sprogcenterToEdit.navn || '',
        adresse: sprogcenterToEdit.adresse || '',
        postnummer: sprogcenterToEdit.postnummer || '',
        forstad: sprogcenterToEdit.forstad || '',
        telefon: sprogcenterToEdit.telefon || '',
        email: sprogcenterToEdit.email || '',
        institutionsnummer: sprogcenterToEdit.institutionsnummer || '',
        organisations_id: sprogcenterToEdit.organisation ? sprogcenterToEdit.organisation.id.toString() : (sprogcenterToEdit.organisations_id ? sprogcenterToEdit.organisations_id.toString() : ''),
        driftsaftaleperiode: sprogcenterToEdit.driftsaftaleperiode || '',
        tilsynskommune: sprogcenterToEdit.tilsynskommune || '',
        udbyder_pd1: sprogcenterToEdit.udbyder_pd1 || false,
        udbyder_pd2: sprogcenterToEdit.udbyder_pd2 || false,
        udbyder_pd3: sprogcenterToEdit.udbyder_pd3 || false,
        udbyder_sp: sprogcenterToEdit.udbyder_sp || false,
        udbyder_vp: sprogcenterToEdit.udbyder_vp || false
      });
    } else {
      setEditingSprogcenterId(null);
      setFormState(initialFormStateSprogcenter);
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false); 
    setModalError(null); 
    setEditingSprogcenterId(null);
  };

  // **RETTELSE: fetchData er nu defineret i komponentens scope**
  const fetchData = async () => {
      setLoading(true); setLoadingOrgOptions(true); setError(null);
      try {
          const fetchOptions = { credentials: 'include' };
          const [sprogcentreRes, orgRes] = await Promise.all([
              fetch(API_BASE_URL_SPROGCENTRE, fetchOptions),
              fetch(API_BASE_URL_ORGANISATIONER, fetchOptions)
          ]);
          if (!sprogcentreRes.ok) throw new Error(`Sprogcentre: ${sprogcentreRes.statusText || sprogcentreRes.status}`);
          if (!orgRes.ok) throw new Error(`Organisationer: ${orgRes.statusText || orgRes.status}`);
          const sprogcentreData = await sprogcentreRes.json();
          const orgData = await orgRes.json();
//          setSprogcentre(sprogcentreData.sort((a,b) => a.id - b.id));
        //  setSprogcentre([...sprogcentreData].sort((a, b) => a.navn.localeCompare(b.navn)));
          setSprogcentre(sprogcentreData);
          setOrganisationerOptions(orgData);
      } catch (err) {
          console.error("Fejl hentning Sprogcentre/Org data:", err); setError(err.message);
      } finally {
          setLoading(false); setLoadingOrgOptions(false);
      }
  };

  // useEffect kalder nu blot den funktion, der er defineret udenfor
  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormState(prevState => ({ ...prevState, [name]: type === 'checkbox' ? checked : value }));
  };

  const resetForm = () => { setFormState(initialFormStateSprogcenter); };

  const handleSprogcenterSubmit = async (event) => {
    event.preventDefault(); setModalError(null);
    if (!formState.navn.trim()) { setModalError('Navn er påkrævet.'); return; }
    
    let orgIdValue = formState.organisations_id ? parseInt(formState.organisations_id, 10) : null;
    if (isNaN(orgIdValue)) orgIdValue = null;

    const sprogcenterData = { ...formState, organisations_id: orgIdValue };

    const submitButton = event.target.querySelector('button[type="submit"]');
    if(submitButton) submitButton.disabled = true;

    try {
      let response;
      const fetchOptions = {
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sprogcenterData),
        credentials: 'include'
      };
      
      if (editingSprogcenterId) {
        response = await fetch(`${API_BASE_URL_SPROGCENTRE}/${editingSprogcenterId}`, {
          method: 'PUT', ...fetchOptions,
        });
      } else {
        response = await fetch(API_BASE_URL_SPROGCENTRE, {
          method: 'POST', ...fetchOptions,
        });
      }
      if (!response.ok) { const errorText = await response.text(); throw new Error(errorText || `Serverfejl: ${response.status}`);}
      
      closeModal();
      await fetchData(); // **Denne virker nu**
      
    } catch (error) {
      console.error(editingSprogcenterId ? "Fejl opdatering sprogcenter:" : "Fejl gemning sprogcenter:", error); 
      setModalError(`Kunne ikke ${editingSprogcenterId ? 'opdatere' : 'gemme'} sprogcenter: ${error.message}`);
    } finally {
        if(submitButton) submitButton.disabled = false;
    }
  };

  const handleDeleteSprogcenter = async (idToDelete) => {
    if (!window.confirm(`Slet sprogcenter med ID ${idToDelete}?`)) return;
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL_SPROGCENTRE}/${idToDelete}`, { 
        method: 'DELETE',
        credentials: 'include'
      });
      if (!response.ok && response.status !== 204) { const errorText = await response.text(); throw new Error(errorText || `Serverfejl: ${response.status}`);}
      
      await fetchData(); // **Denne virker nu**

    } catch (error) {
      console.error("Fejl ved sletning af sprogcenter:", error); setError(`Kunne ikke slette: ${error.message}`);
    }
  };

  return (
    <div>
      <div className="add-new-button-container">
        <button onClick={() => openModal()} className="toggle-form-button primary-action" disabled={loadingOrgOptions}>
            {loadingOrgOptions ? 'Henter data...' : 'Tilføj Nyt Sprogcenter'}
        </button>
      </div>
      <h2 className="page-main-header">Eksisterende Sprogcentre</h2>
      {error && !modalIsOpen && <p className="error-message" style={{textAlign: 'center'}}>{error}</p>}
      
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} contentLabel={editingSprogcenterId ? "Rediger Sprogcenter" : "Tilføj Nyt Sprogcenter"} className="ReactModal__Content" overlayClassName="ReactModal__Overlay">
        <form onSubmit={handleSprogcenterSubmit} className="modal-form">
          <h3>{editingSprogcenterId ? `Rediger Sprogcenter (ID: ${editingSprogcenterId})` : 'Tilføj Nyt Sprogcenter'}</h3>
          {modalError && <p className="error-message" style={{marginBottom: '15px'}}>{modalError}</p>}

          <div className="form-field"><label htmlFor="navnModalSp">Navn:*</label><input type="text" id="navnModalSp" name="navn" value={formState.navn} onChange={handleInputChange} required /></div>
          <div className="form-field"><label htmlFor="adresseModalSp">Adresse:</label><input type="text" id="adresseModalSp" name="adresse" value={formState.adresse} onChange={handleInputChange} /></div>
          <div className="form-row">
            <div className="form-field"><label htmlFor="postnummerModalSp">Postnr.:</label><input type="text" id="postnummerModalSp" name="postnummer" value={formState.postnummer} onChange={handleInputChange} /></div>
            <div className="form-field"><label htmlFor="forstadModalSp">Forstad/By:</label><input type="text" id="forstadModalSp" name="forstad" value={formState.forstad} onChange={handleInputChange} /></div>
          </div>
          <div className="form-row">
            <div className="form-field"><label htmlFor="telefonModalSp">Telefon:</label><input type="tel" id="telefonModalSp" name="telefon" value={formState.telefon} onChange={handleInputChange} /></div>
            <div className="form-field"><label htmlFor="emailModalSp">Email:</label><input type="email" id="emailModalSp" name="email" value={formState.email} onChange={handleInputChange} /></div>
          </div>
          <div className="form-row">
            <div className="form-field"><label htmlFor="institutionsnummerModalSp">Inst.nr.:</label><input type="text" id="institutionsnummerModalSp" name="institutionsnummer" value={formState.institutionsnummer} onChange={handleInputChange} /></div>
            <div className="form-field">
                <label htmlFor="organisations_idModalSp">Organisation:</label>
                <select id="organisations_idModalSp" name="organisations_id" value={formState.organisations_id} onChange={handleInputChange} disabled={loadingOrgOptions}>
                    <option value="">-- Vælg Organisation (valgfrit) --</option>
                    {loadingOrgOptions ? <option disabled>Henter...</option> : organisationerOptions.map(org => (<option key={org.id} value={org.id}>{org.navn} (ID: {org.id})</option>))}
                </select>
            </div>
          </div>
          <div className="form-row">
            <div className="form-field"><label htmlFor="driftsaftaleperiodeModalSp">Driftsaftaleperiode:</label><input type="text" id="driftsaftaleperiodeModalSp" name="driftsaftaleperiode" value={formState.driftsaftaleperiode} onChange={handleInputChange} /></div>
            <div className="form-field"><label htmlFor="tilsynskommuneModalSp">Tilsynskommune:</label><input type="text" id="tilsynskommuneModalSp" name="tilsynskommune" value={formState.tilsynskommune} onChange={handleInputChange} /></div>
          </div>
          <fieldset style={{ border:'1px solid #ccc', padding:'10px', marginBottom:'15px', borderRadius:'4px' }}>
            <legend style={{fontWeight:'bold', color:'#555'}}>Udbyder Prøver:</legend>
            <div className="form-row" style={{ marginBottom: '0', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                <div className="form-field-check"><input type="checkbox" id="udbyder_pd1ModalSp" name="udbyder_pd1" checked={formState.udbyder_pd1} onChange={handleInputChange} /><label htmlFor="udbyder_pd1ModalSp">PD1</label></div>
                <div className="form-field-check"><input type="checkbox" id="udbyder_pd2ModalSp" name="udbyder_pd2" checked={formState.udbyder_pd2} onChange={handleInputChange} /><label htmlFor="udbyder_pd2ModalSp">PD2</label></div>
                <div className="form-field-check"><input type="checkbox" id="udbyder_pd3ModalSp" name="udbyder_pd3" checked={formState.udbyder_pd3} onChange={handleInputChange} /><label htmlFor="udbyder_pd3ModalSp">PD3</label></div>
                <div className="form-field-check"><input type="checkbox" id="udbyder_spModalSp" name="udbyder_sp" checked={formState.udbyder_sp} onChange={handleInputChange} /><label htmlFor="udbyder_spModalSp">SP</label></div>
                <div className="form-field-check"><input type="checkbox" id="udbyder_vpModalSp" name="udbyder_vp" checked={formState.udbyder_vp} onChange={handleInputChange} /><label htmlFor="udbyder_vpModalSp">VP</label></div>
            </div>
          </fieldset>
          <div className="modal-actions">
            <button type="submit" disabled={loadingOrgOptions}>
                {loadingOrgOptions ? 'Vent...' : (editingSprogcenterId ? 'Gem Ændringer' : 'Opret Sprogcenter')}
            </button>
            <button type="button" onClick={closeModal} className="cancel-button">Annuller</button>
          </div>
        </form>
      </Modal>

      {loading && <p className="info-message">Henter sprogcentre...</p>}
      {!loading && sprogcentre.length === 0 && !error && (<p className="info-message">Ingen sprogcentre fundet.</p>)}
      {!loading && sprogcentre.length > 0 && (
        <div className="table-container">
          <table className="censor-table"> 
          <thead>
              <tr>
                <th>Navn & Adresse</th>
                <th>Telefon</th>
                <th>Email</th>
                <th>Organisation</th>
                <th>Udbyder Prøver</th>
                <th className="action-cell">Handlinger</th>
              </tr>
            </thead>
            <tbody>
              {sprogcentre.map(sc => (
                <tr key={sc.id}>
                  {/* ID CELLEN ER FJERNET */}
                  
                  {/* Navn & Adresse */}
                  <td>
                    <strong>{sc.navn}</strong>
                    {sc.adresse && <><br /><small>{sc.adresse}, {sc.postnummer} {sc.forstad}</small></>}
                  </td>

                  {/* Separate celler for Telefon og Email */}
                  <td>{sc.telefon || '-'}</td>
                  <td>{sc.email || '-'}</td>
                  
                  {/* Organisation */}
                  <td>{sc.organisation ? sc.organisation.navn : (sc.organisations_id ? `Org. ID: ${sc.organisations_id}`: 'N/A')}</td>
                  
                  {/* Udbyder Prøver */}
                  <td>
                    <small>
                      {sc.udbyder_pd1 && 'PD1 '}
                      {sc.udbyder_pd2 && 'PD2 '}
                      {sc.udbyder_pd3 && 'PD3 '}
                      {sc.udbyder_sp && 'SP '}
                      {sc.udbyder_vp && 'VP'}
                      {!sc.udbyder_pd1 && !sc.udbyder_pd2 && !sc.udbyder_pd3 && !sc.udbyder_sp && !sc.udbyder_vp && '-'}
                    </small>
                  </td>
                  <td className="action-cell">
                    <button onClick={() => openModal(sc)} className="edit-button icon-button" title={`Rediger ${sc.navn}`} style={{ marginRight: '8px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px"><path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" /><path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" /></svg>
                    </button>
                    <button onClick={() => handleDeleteSprogcenter(sc.id)} className="delete-button icon-button" title={`Slet ${sc.navn}`}>
                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px" className="delete-icon"><path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.9h1.368c1.603 0 2.816 1.336 2.816 2.9zm-1.452.721a.75.75 0 01.216-.534l.018-.018a.75.75 0 01.706-.216L17.5 5.25a.75.75 0 01.216.534l-.018.018a.75.75 0 01-.706.216l-1.281-.214a.75.75 0 01-.216-.534z" clipRule="evenodd" /></svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default SprogcentreListe;